const TOKEN_KEY = 'auth_token';
const USER_KEY = 'user_data';

export const tokenManager = {
  getToken: (): string | null => {
    return localStorage.getItem(TOKEN_KEY);
  },

  setToken: (token: string): void => {
    localStorage.setItem(TOKEN_KEY, token);
  },

  clearTokens: (): void => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
  },

  getUser: <T>(): T | null => {
    const userData = localStorage.getItem(USER_KEY);
    return userData ? JSON.parse(userData) : null;
  },

  setUser: <T>(user: T): void => {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  },

  isAuthenticated: (): boolean => {
    return !!tokenManager.getToken();
  },
};

// Initialize the API client with token manager functions
// This is done to avoid circular dependency
import { setTokenManager } from '@/lib/api/client';
setTokenManager(tokenManager.getToken, tokenManager.clearTokens);
